export default "__VITE_ASSET__CcBE1h5i__"